/**
 *  Simple Dropdown
 *  v1.0
 *  Onepixel - shess
 *  feb 2021
 *  @need _dropdown.scss component
 */

const dropdown = document.querySelectorAll('.js-dropdown')

if (dropdown.length) {

  dropdown.forEach(itemDrop => {
    itemDrop.addEventListener('click', function () {
      const currentDrop = this
      // If clicked on dropdwon or child elements
      dropdown.forEach(itemDrop => {
        if (currentDrop != itemDrop) {
          // close all but current
          itemDrop.classList.remove('is-open')
        } else if (currentDrop.classList.contains('is-open')) {
          // remove current if already open
          currentDrop.classList.remove('is-open')
        } else {
          // open current if closed
          currentDrop.classList.add('is-open')
        }
      })
    })
  })

  // Watch if clicked outside and close dropdown
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.js-dropdown')) {
      // console.log('clicked outside')
      dropdown.forEach(itemDrop => {
        itemDrop.classList.remove('is-open')
      })
    }
  }, false);

}



// WEBPACK FOOTER //
// ./scripts/autoload/dropdown.js